import { createIcon } from './icon-utils';

export const VertDotsIcon = createIcon({
  fillRule: 'evenodd',
  path: 'M11 7.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5S13.328 9 12.5 9 11 8.328 11 7.5zm0 10c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5zm0-5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5z',
});
